// @ts-strict-ignore
import { CheckCircle2, Circle, Star } from "lucide-react";
import React from "react";

interface AddOnCardProps {
  title: string;
  price: string; // e.g. "$150/mo"
  features: string[];
  active?: boolean;
}

const AddOnCard: React.FC<AddOnCardProps> = ({ title, price, features, active }) => {
  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        padding: 16,
        background: active ? "#eef2ff" : "#fff",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
        <div style={{ color: "#6b7280", fontSize: 12 }}>{title}</div>
        <button
          title={active ? "Saved" : "Save"}
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            width: 32,
            height: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Star size={16} color="#6b7280" />
        </button>
      </div>

      <div style={{ fontSize: 24, fontWeight: 800, marginBottom: 10 }}>{price}</div>

      <div style={{ display: "grid", gap: 8, marginBottom: 12 }}>
        {features.map((f, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, color: "#374151" }}>
            <Circle size={16} />
            <span style={{ fontSize: 16 }}>{f}</span>
          </div>
        ))}
      </div>

      <div>
        {active ? (
          <button
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 8,
              border: "none",
              background: "#4f46e5",
              color: "#fff",
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
            }}
          >
            Activated <CheckCircle2 size={16} />
          </button>
        ) : (
          <button
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid #e5e7eb",
              background: "#fff",
              color: "#111827",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Get Add On
          </button>
        )}
      </div>
    </div>
  );
};

export default AddOnCard;
